// extracted by mini-css-extract-plugin
module.exports = {"PlatformSummary":"PlatformSummary_PlatformSummary__3TzkE","PlatformSummaryCard":"PlatformSummary_PlatformSummaryCard__2JBaX"};